import {fetchWithTimeout, checkPermission, TIMEOUT, PERMISSION_ADMIN, PERMISSION_OPERATOR, PERMISSION_MONITORING} from './api_common';
import {getCookie, showToast, getFetchError, getCatchError} from '../app_common.js';

export const getApiConfigEndpoint = async() => {
    if( !checkPermission('getApiConfigEndpoint', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/endpoint`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                'accept' : 'application/json',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiConfigEndpoint = async(sendData) => {
    if( !checkPermission('postApiConfigEndpoint', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/endpoint`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiConfigEndpointStatus = async() => {
    if( !checkPermission('getApiConfigEndpointStatus', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/endpoint-status`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                'accept' : 'application/json',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiConfigReport = async() => {
    if( !checkPermission('getApiConfigReport', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/report`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                'accept' : 'application/json',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiConfigReport = async(SendData) => {
    if( !checkPermission('postApiConfigReport', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/report`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(SendData),
        })

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiConfigSystem = async() => {
    if( !checkPermission('getApiConfigSystem', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/system`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                'accept' : 'application/json',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiConfigSystem = async(sendData) => {
    if( !checkPermission('postApiConfigSystem', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/system`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                'Content-Type' : 'application/json',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiConfigTag = async() => {
    if( !checkPermission('getApiConfigTag', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/tag`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                'accept' : 'application/json',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiConfigTag = async(sendData) => {
    if( !checkPermission('postApiConfigTag', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/tag`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiConfigLocation = async() => {
    if( !checkPermission('getApiConfigLocation', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/location`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                'accept' : 'application/json',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiConfigLocation = async(sendData) => {
    if( !checkPermission('postApiConfigLocation', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/location`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiConfigSiteEndpoint = async() => {
    if( !checkPermission('getApiConfigSiteEndpoint', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/site-endpoint`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                'accept' : 'application/json',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiConfigSiteEndpoint = async(sendData) => {
    if( !checkPermission('postApiConfigSiteEndpoint', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/site-endpoint`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiConfigSiteEndpointEmailTest = async(sendData) => {
    if( !checkPermission('postApiConfigSiteEndpointEmailTest', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/site-endpoint/email/test`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}